import React, { type ReactElement } from "react";
import { components, type GroupBase, type MultiValueRemoveProps } from "react-select";

import styles from "~/ui/react-select.global.module.css";

const RMultiValueRemove = components.MultiValueRemove;

type MultiValueRemoveType = <
	Option = unknown,
	IsMulti extends boolean = false,
	Group extends GroupBase<Option> = GroupBase<Option>,
>(
	props: MultiValueRemoveProps<Option, IsMulti, Group>,
) => ReactElement;

export const MultiValueRemove: MultiValueRemoveType = props => {
	return <RMultiValueRemove {...props} />;
};

export default {
	className: styles.reactSelect,
	classNamePrefix: "react-select-fellow",
};
